var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toaster"},_vm._l((_vm.loaf),function(bread,index){return _c('div',{key:index},[_c('Toast',{attrs:{"toast":bread}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }